module.exports = __webpack_public_path__ + "img/message.f22dea43.svg";